import CONSTANTS from '../../constants';

export function schedule(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.APPOINTMENT.GET.SCHEDULE:
            return action.classes;
        default:
            return state
    }
}